import { useEffect } from 'react';
import { debounce } from 'lodash';

export default function useScrollHeader(setHeaderDark, threshold = 50) {
  useEffect(() => {
    const handleScroll = debounce(() => {
      if (window.scrollY > threshold) {
        setHeaderDark(true);
      } else {
        setHeaderDark(false);
      }
    }, 100);

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      handleScroll.cancel?.(); // 如果使用 lodash 的 debounce
      setHeaderDark(false);
    };
  }, [setHeaderDark, threshold]);
}